module.exports = __webpack_public_path__ + "static/media/model-patrol-97-lwb.d3cb1ae3.webp";